export const CUSTOM_MAPPING = {
    SELECT_OPTION: "select-option",
    AUTOCOMPLETE_COMPONENT: "autocomplete-component",
    DELETE_BUTTON: "delete-button",
    ADD_BUTTON: "add-button",
    ERROR_MESSAGE_DIV: "error-message-div",
};
